import React from "react"
import { Label } from "@/components/shadcn/ui/label"
import { Textarea } from "@/components/shadcn/ui/textarea"
import { ParagraphField } from "@/models/new/forms.types"
import { ResponseValue, ParagraphResponse } from "@/models/new/formResponse.types"

interface Props {
  field: ParagraphField
  value?: ResponseValue
  onChange: (fieldId: string, value: ResponseValue) => void
}

const TextAreaField = (props: Props) => {
  const { field, value, onChange } = props

  const currentValue = value?.type === "paragraph" ? (value as ParagraphResponse).value : ""

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(field.id, {
      fieldName: field.name,
      type: "paragraph",
      value: e.target.value,
    })
  }

  return (
    <React.Fragment>
      <div className="w-1/2 p-4">
        <div>
          <Label>{field.label}</Label>
          <Textarea value={currentValue} onChange={handleChange} className="bg-white mt-1" rows={4} />
        </div>
      </div>
    </React.Fragment>
  )
}

export default TextAreaField
